import { Injectable } from '@angular/core';
import { Actions,createEffect,ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of,throwError } from 'rxjs';
import { catchError,concatMap,map,switchMap,withLatestFrom } from 'rxjs/operators';
import { HttpService } from '../../../services/http.service';
import { DaveActions } from '../../actions/actions';
import { BaseActionTypes } from '../../actions/base.actions';
import {
    Customer2QualificationActionTypes, DeleteCustomer2QualificationRequest, DeleteCustomer2QualificationResponse,
    GetCustomer2QualificationResponse, PostCustomer2QualificationRequest, PostCustomer2QualificationResponse,
} from '../../actions/mdqx/customer2qualification.action';

import { Customer2QualificationEntity } from '../../../entities/mdqx/customer2qualification.entity';
import { getToken } from '../../selectors/base.selectors';
import { State } from '../../index';
import {
    Contract2PlausibilitaetActionTypes,
    PostContract2PlausibilitaetResponse,
} from '../../actions/mdqx/contract2plausibilitaet.actions';
import { Contract2PlausibilitaetEntity } from '../../../entities/mdqx/contract2plausibilitaet.entity';
import { environment } from '../../../../../environments/environment';



enum ErrorCodes {
    Get = 'Qualifikationszuordnungen Abrufen fehlgeschlagen',
    Post = 'Qualifikationszuordnung Anlegen fehlgeschlagen',
    Delete = 'Qualifikationszuordnung Löschen fehlgeschlagen',
}

@Injectable()
export class Customer2QualificationEffects {
    get$ = createEffect(() => this.actions$.pipe(
        ofType(Customer2QualificationActionTypes.GetRequest),
        map(
            () => `
            {
                customer2Qualification {
                    ${Customer2QualificationEntity.GqlFields}
                }
            }`,
        ),
        withLatestFrom(this.store.select(getToken)),
        switchMap(([query, token]) =>
            this.api.graphQl({ query }, { token, retry: true }, '', environment.mdqxGatewayApiUrl).pipe(
                map(res => {
                    return res && res.customer2Qualification;
                }),
                concatMap(res =>
                    res
                        ? [
                            new GetCustomer2QualificationResponse(
                                res.map(
                                    customer2Qualification =>
                                        new Customer2QualificationEntity(
                                            customer2Qualification,
                                        ),
                                ),
                            ),
                        ]
                        : throwError('empty response'),
                ),
                catchError((err, caught) => of(BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage: ErrorCodes.Get,
                        Err: err,
                        Caught: caught,
                    }
                }))),
            ),
        ),
    ));


    post$ = createEffect(() => this.actions$.pipe(
        ofType(Customer2QualificationActionTypes.PostRequest),
        map(
            ({ Payload }) => `
            mutation {
                createCustomer2Qualification(
                    customerId: ${JSON.stringify(Payload.customerId)}
                    qualificationId: ${JSON.stringify(Payload.qualificationId)}
                ) {
                    ${Customer2QualificationEntity.GqlFields}
                }
            }`,
        ),
        withLatestFrom(this.store.select(getToken)),
        concatMap(([query, token]) =>
            this.api.graphQl({ query }, { token, retry: true }, '', environment.mdqxGatewayApiUrl).pipe(
                map(res => res && res.createCustomer2Qualification),
                concatMap(res =>
                    res
                        ? [
                            new PostCustomer2QualificationResponse(
                                new Customer2QualificationEntity(res),
                            ),
                        ]
                        : throwError('empty response'),
                ),
                catchError((err, caught) => of(BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage: ErrorCodes.Post,
                        Err: err,
                        Caught: caught,
                    }
                }))),
            ),
        ),
    ));

    delete$ = createEffect(() =>
        this.actions$.pipe(
            ofType(Customer2QualificationActionTypes.DeleteRequest),
            withLatestFrom(this.store.select(getToken)),
            concatMap(([action, token]: [DeleteCustomer2QualificationRequest, string]) => {
                const { customerId, qualificationId } = action.Payload;

                const query = `
                    mutation {
                        deleteCustomer2Qualification(
                            customerId: ${JSON.stringify(customerId)},
                            qualificationId: ${JSON.stringify(qualificationId)}
                        )
                    }
                `;

                return this.api.graphQl({ query }, { token, retry: true }, '', environment.mdqxGatewayApiUrl).pipe(
                    map(res => res && res.deleteCustomer2Qualification),
                    concatMap(res =>
                        res
                            ? of(new DeleteCustomer2QualificationResponse({
                                customerId,
                                qualificationId
                            }))
                            : throwError(() => new Error('falsy response'))
                    ),
                    catchError((err, caught) =>
                        of(BaseActionTypes.ErrorAction({
                            Payload: {
                                ToasterMessage: ErrorCodes.Delete,
                                Err: err,
                                Caught: caught,
                            },
                        }))
                    )
                );
            })
        )
    );


    constructor(private actions$: Actions<DaveActions>, private api: HttpService, private store: Store<State>) {}
}
